import {
  LayoutListDefinition,
  LAYOUT_LIST,
  CARD_TYPE_SELECTION_PLACEHOLDER,
  EDITABLE_CARD_WRAPPER
} from '../../items';
import { Translator } from '../../Translator';
import { CardHelper } from '../itemHelpers/CardHelper';
import { ItemOfType } from '../itemHelpers/types';
import { translate } from '../translate';
import { TextHelper } from '~/training/sequence/templates/translators/itemHelpers/TextHelper';
import { useEditorStore } from '~/shell/Store';
import { CardTypeSelectionPlaceholderDefinition } from '~/editor/v2/cards/CardTypeSelectionPlaceholder';
import { EditableCardWrapperDefinition } from '~/editor/v2/cards/EditableCardWrapper';
import { textCardTemplate } from './templates/textCard';
import { imageCardTemplate } from './templates/imageCard';
import { imageAudioCardTemplate } from './templates/imageAudioCard';

export const Cards4: Translator = sequence => {
  const { contentEditable } = useEditorStore.getState();

  const cardTemplates = [
    textCardTemplate,
    imageAudioCardTemplate,
    imageCardTemplate
  ];

  const cardsList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.cardlist`,
    values: {
      orientation: 'row',
      align: 'center',
      wrap: true,
      padded: true,
      type: 'ul'
    },
    items: []
  } as LayoutListDefinition;

  const mainList = {
    type: LAYOUT_LIST,
    id: `${sequence.id}.list`,
    values: {
      orientation: 'column',
      align: 'center',
      padded: true
    },
    items: []
  } as LayoutListDefinition;

  const root = translate(sequence, item => {
    if (item.__typename === 'Card') {
      const cardDefinition = CardHelper(item as ItemOfType<'Card'>, {
        width: { _: '241px', lg: '268px' },
        height: { _: '338px', lg: '376px' },
        padding: '0px',
        canScroll: true,
        align: 'safeCenter',
        overflow: 'auto',
        type: contentEditable ? 'div' : 'li',
        editable: false
      });

      if (contentEditable) {
        cardsList.items.push({
          type: EDITABLE_CARD_WRAPPER,
          id: `${sequence.id}.wrapper.${item.id}`,
          values: {
            cardId: item.id,
            width: { _: '241px', lg: '268px' },
            height: { _: '338px', lg: '376px' },
            cardTemplates
          },
          items: [cardDefinition]
        } as EditableCardWrapperDefinition);
      } else {
        cardsList.items.push(cardDefinition);
      }
    } else if (item.__typename === 'Text') {
      mainList.items.push({
        type: LAYOUT_LIST,
        id: `${sequence.id}.list`,
        values: {
          align: 'top',
          padding: '50px 0px 0px 0px'
        },
        items: TextHelper(item as ItemOfType<'Text'>)
      } as LayoutListDefinition);
    }

    return null;
  });

  if (contentEditable) {
    cardsList.items.push({
      type: CARD_TYPE_SELECTION_PLACEHOLDER,
      id: `${sequence.id}.add-card`,
      values: {
        sequenceId: sequence.id,
        text: 'Add Card',
        width: '268px',
        height: '376px',
        cardTemplates
      }
    } as CardTypeSelectionPlaceholderDefinition);
  }

  mainList.items.push(cardsList);
  if (mainList.items.length > 1) {
    mainList.items.push({
      type: LAYOUT_LIST,
      id: `${sequence.id}.blank`
    } as LayoutListDefinition);
  }
  root.items.push(mainList);

  return root;
};
